import React from 'react';
import { Trigger } from './Trigger';
import { TriggerProvider } from './TriggerContext';
import { useApi } from '@backstage/core-plugin-api';
import { triggerApiRef } from '../../../api';
import { useProjectName } from '../../useProjectName';
import { LocationResolver, ProjectNameResolver } from './types';
import { getLocation } from '../../useLocation';
import { Entity } from '@backstage/catalog-model';

export const TriggerWithProviders = ({ entity }: { entity: Entity }) => {
  const api = useApi(triggerApiRef);
  const { value: projectName, loading, error } = useProjectName(entity);

  if (loading) {
    return <div>Loading project name...</div>;
  }

  if (error) {
    return <div>Error loading project name: {error.message}</div>;
  }

  // Set up resolvers after project name is available
  const projectNameResolver: ProjectNameResolver = {
    getProjectName: async () => projectName,
  };

  const locationResolver: LocationResolver = {
    getLocation: e => getLocation(e),
  };

  return (
    <TriggerProvider
      api={api}
      projectNameResolver={projectNameResolver}
      locationResolver={locationResolver}
    >
      <Trigger entity={entity} />
    </TriggerProvider>
  );
};
